export { default } from "./GuidedHighlightingIcon.js";
